"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StarIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "20",
  height: "19",
  viewBox: "0 0 20 19",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-1199.000000, -237.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(1200.000000, 238.000000)",
        fill: color,
        fillRule: "nonzero",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M5.691,4.445 L0.296693037,5.22924004 L0.182916722,5.25217029 C-0.552630247,5.44344861 -0.822774642,6.38394664 -0.257520337,6.93493341 L3.645,10.739 L2.72432441,16.1121079 L2.71129625,16.2222255 C2.66190665,16.9835628 3.47499317,17.5344437 4.17527386,17.1662844 L9,14.63 L13.8247261,17.1662844 L13.9254283,17.2127031 C14.6342409,17.4949416 15.4094173,16.8918819 15.2756756,16.1121079 L14.354,10.739 L18.2575203,6.93493341 L18.3360892,6.84950641 C18.8187287,6.26241534 18.4844692,5.34274955 17.703307,5.22924004 L12.308,4.445 L9.89673608,-0.442565711 C9.52992239,-1.18581143 8.47007761,-1.18581143 8.10326392,-0.442565711 L5.691,4.445 Z M9,2.258 L10.7482976,5.80198924 L10.8091121,5.90829217 C10.9650407,6.14581816 11.2162389,6.30761814 11.5012353,6.34903054 L15.41,6.917 L12.5817426,9.67449011 L12.4994353,9.76517757 C12.3217192,9.9868741 12.2454628,10.2757767 12.294146,10.5596215 L12.962,14.453 L9.46534113,12.6148686 L9.35365785,12.5646136 C9.08789465,12.4641036 8.78956739,12.4808552 8.53465887,12.6148686 L5.037,14.453 L5.705854,10.5596215 L5.71913732,10.4378748 C5.73260267,10.1540597 5.62448269,9.87551012 5.41825737,9.67449011 L2.589,6.917 L6.49876468,6.34903054 C6.82447484,6.30170208 7.10604043,6.09713271 7.25170244,5.80198924 L9,2.258 Z"
        })
      })
    })
  })]
});

StarIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = StarIcon;
exports.default = _default;